import { memo, ReactNode } from "react";
import { Link } from "../Link";

import styles from "./style.module.scss";

export type LabelWithViewLinkProps = {
  label?: ReactNode
  to?: string
}

export const LabelWithViewLink = memo<LabelWithViewLinkProps>(({ label, to }) =>
  to ?
    (
      <span className={styles.root}>
        <span className={styles.label}>{label}</span>
        <Link tabIndex={-1} linkType="s" to={to}>View</Link>
      </span>
    )
    : <>{label}</>,
);

export default LabelWithViewLink;
